export default "__VITE_ASSET__B5J_MhlT__"